import React, {createContext, useState} from 'react';
import ConfirmationDialog from "./ConfirmationDialog";
import useDialogState from "../../../hooks/useDialogState";

export const ConfirmationDialogContext = createContext(() => {});

export default function ConfirmationDialogProvider(props) {
    const [confirmationMessage, setConfirmationMessage] = useState('');
    const [callbacks, setCallbacks] = useState({
        onAgree: () => {},
        onDisagree: () => {}
    });
    const {
        dialogState,
        openDialog,
        closeDialog
    } = useDialogState({
        confirmation: false
    });

    const confirmation = (confirmationMessage = '', handleAgree = () => {}, handleDisagree = () => {}) => {
        setConfirmationMessage(confirmationMessage);

        setCallbacks({
            onAgree: handleAgree,
            onDisagree: handleDisagree
        });

        openDialog('confirmation')();
    };

    return (
        <ConfirmationDialogContext.Provider value={confirmation}>
            <ConfirmationDialog
                confirmationMessage={confirmationMessage}
                open={dialogState.confirmation}
                onClose={closeDialog('confirmation')}
                onAgree={callbacks.onAgree}
                onDisagree={callbacks.onDisagree} />
            {props.children}
        </ConfirmationDialogContext.Provider>
    );
}